import React from 'react';
import {
    useOrderExpectedInString,
    useOrderIsSyncingTimeSlots,
} from '@/hooks/api/order';

const OrderTimeLabel = () => {
    const expected_in_string = useOrderExpectedInString();
    const is_syncing = useOrderIsSyncingTimeSlots();

    if (!expected_in_string && !is_syncing) {
        return null;
    }

    return (
        <div
            data-expected-in-string
            data-is-loading={is_syncing}
            className="m2g-order-expected-in-string m2g-text--small m2g-text--offset"
        >
            {expected_in_string || 'loading'}
            {/* 'loading' is filler for skeleton loading state */}
        </div>
    );
};
export default OrderTimeLabel;
